import { Injectable, inject } from '@angular/core';

import { ConfigStateService, RoutesService, isNullOrUndefined } from '@abp/ng.core';
import { tap } from 'rxjs';

import { createEffect } from '@nexweb/shared/effects';
import { FeatureFlagNames } from '@nexweb/shared/guards/feature-flag';

import { bulkDownloadMenuName } from './constants';

@Injectable({ providedIn: 'root' })
export class BulkDownloadEffects {
  bulkDownloadEffect$ = createEffect(() => {
    const configStateService = inject(ConfigStateService);
    const routes = inject(RoutesService);

    return configStateService.getFeature$(FeatureFlagNames.bulkDownloadEnabled).pipe(
      tap((featureFlag: string) => {
        if (!isNullOrUndefined(featureFlag)) {
          const featureValue = JSON.parse(featureFlag);

          routes.patch(bulkDownloadMenuName, { invisible: !featureValue });
        }
      }),
    );
  });
}
